<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
      <i :class="icon"/>
        {{name}}
      <span v-if="name == '주문관리'" class="badge badge-danger neworderflag" style="float:none; font-size:12px; margin:0px; color:#ffffff; display:none;" >
        <i class="fa fa-exclamation fa-lg" style="color:#ffffff; width:0px"/>NEW
      </span>
      <span
        v-if="name == '고객센터관리' && isQnaShow"
        class="badge badge-danger"
        style="float:none; font-size:12px; margin:0px; color:#ffffff;" >
        <i class="fa fa-exclamation fa-lg" style="color:#ffffff; width:0px"/>NEW
      </span>
    </div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
import {EventBus} from "../../views/event-bus";

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isQnaShow: false
    }
  },
  // 신규 qna 문의 노출용 이벤트 버스
  created() {
    EventBus.$on('showQnaNew', (qnaCnt) => {
      if (qnaCnt > 0) {
        this.isQnaShow = true;
      } else {
        this.isQnaShow = false;
      }
    });
  },
  methods: {
    handleClick (e) {
      // this.$store.dispatch('ORDERTOTALCNT', this);
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarNavDropdown.vue